import moment from "moment-timezone";
import "moment/locale/el";

export const DEFAULT_TIMEZONE = "Europe/Athens";

export function formatAdminDate(value, locale = "el") {
  if (!value) return "—";
  const parsed = moment.utc(value).locale(locale);
  return parsed.isValid() ? parsed.format("L") : value;
}

export function formatAdminDateTime(value, timezone = DEFAULT_TIMEZONE, locale = "el") {
  if (!value) return "—";
  const parsed = moment(value);
  const targetTimezone = moment.tz.zone(timezone) ? timezone : DEFAULT_TIMEZONE;
  return parsed.isValid() ? parsed.tz(targetTimezone).locale(locale).format("L LT z") : value;
}

// gos-admin never prints a bare timestamp in a table: getTimestampMeta
// turns every value into "how long ago" with the full date waiting behind
// a tooltip, so a list stays scannable and the precise moment is still one
// hover away. This is that helper, kept organisation-timezone aware so an
// Athens operator reading a New York client still sees the client's clock.
export function adminTimestampMeta(value, timezone = DEFAULT_TIMEZONE, locale = "el") {
  if (!value) {
    return { isValid: false, relative: "—", full: "—" };
  }

  const parsed = moment(value);

  if (!parsed.isValid()) {
    return { isValid: false, relative: String(value), full: String(value) };
  }

  const targetTimezone = moment.tz.zone(timezone) ? timezone : DEFAULT_TIMEZONE;
  const localized = parsed.tz(targetTimezone).locale(locale);

  return {
    isValid: true,
    relative: localized.fromNow(),
    full: localized.format("dddd, D MMMM YYYY, HH:mm z"),
  };
}

export function adminDateDaysAgo(days, timezone = DEFAULT_TIMEZONE) {
  const targetTimezone = moment.tz.zone(timezone) ? timezone : DEFAULT_TIMEZONE;
  return moment.tz(targetTimezone).subtract(days, "days").format("YYYY-MM-DD");
}
